import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  categories: null,
  loading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CATEGORIES_CONTROLS:
      return updateObject(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
